<div class="common-header-font mt-3 ml-2">Identification</div>
<div class="mt-3">
    <ng-container *ngFor="let image of imageUrlArray let i=index">
        <p-image *ngIf="!image.isPdf" class="mr-2 pointer-img" [src]="image.url ? image.url : 'XpressApp/assets/images/vehicle/no-data.jpg'" alt="Image" height="150" width="150" [preview]="true"></p-image>
        <p-image *ngIf="image.isPdf" class="pointer-img" src="XpressApp\assets\images\pdf-icon.png" height="150" width="150" (click)="showDocs(image)"></p-image>
    </ng-container>
    
    <div class="flex title-float-right left-block-bottom-btns mt-3">
        <img class="export-icon ml-4" src="Content/xpress-app/images/operator/signup/upload_files.svg" alt='' height="14" width="14">
        <div class="btn-profile btn-default btn-upload" (click)="toggleUploadPopup()">Upload</div>
    </div>
</div>

<p-dialog *ngIf="isDocsShown && isPdfDoc" (onHide)="reset()" [visible]="isDocsShown && isPdfDoc" (visibleChange)="isDocsShown && (isPdfDoc = $event)" [modal]="true" [style]="{width: '70vw'}" [resizable]="false">
    <iframe [src]="docURL[0]" width="100%" height="500px" frameborder="0"></iframe>
</p-dialog>

<upload-document-modal *ngIf="showUploadDocumentsPopup" (hideUploadModal)="closeUploadPopup($event)" 
[showUploadDocumentsPopup]="showUploadDocumentsPopup" [profile]="profile" (updateUserProfile)="updateProfile($event)">
</upload-document-modal>
<confirm-modal [discardConfirmDialog]="discardConfirmDialog" (hideConfirmModal)="hideConfirmModal($event)"></confirm-modal>